import { MapPin, Phone, Clock, Send, Instagram } from 'lucide-react';

export default function Contact() {
  const handleWhatsApp = () => {
    const message = encodeURIComponent("Hi, I'd like to book an appointment at Magic Touch Salon.");
    window.open(`https://wa.me/919870214490?text=${message}`, '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+919870214490';
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-white">
            Get in <span className="text-[#D4AF37]">Touch</span>
          </h1>
          <p className="text-lg text-[#A3A3A3] max-w-2xl mx-auto">
            Visit us or reach out for appointments and inquiries
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          {/* Contact Information */}
          <div className="space-y-8">
            <div className="bg-neutral-900 border border-neutral-800 p-8 hover:border-[#D4AF37]/50 transition-colors duration-300">
              <div className="flex items-start space-x-4">
                <MapPin className="text-[#D4AF37] flex-shrink-0 mt-1" size={32} />
                <div>
                  <h3 className="text-2xl font-bold mb-2 text-white">Location</h3>
                  <p className="text-[#A3A3A3] leading-relaxed">
                    12/B, Gokul Galaxy,<br />
                    Thakur Complex,<br />
                    Kandivali East,<br />
                    Mumbai, Maharashtra 400101
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-neutral-900 border border-neutral-800 p-8 hover:border-[#D4AF37]/50 transition-colors duration-300">
              <div className="flex items-start space-x-4">
                <Phone className="text-[#D4AF37] flex-shrink-0 mt-1" size={32} />
                <div>
                  <h3 className="text-2xl font-bold mb-2 text-white">Contact</h3>
                  <div className="space-y-2">
                    <a
                      href="tel:+919870214490"
                      className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-lg block"
                    >
                      +91 98702 14490
                    </a>
                    <a
                      href="tel:+918828817070"
                      className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-lg block"
                    >
                      +91 88288 17070
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-neutral-900 border border-neutral-800 p-8 hover:border-[#D4AF37]/50 transition-colors duration-300">
              <div className="flex items-start space-x-4">
                <Clock className="text-[#D4AF37] flex-shrink-0 mt-1" size={32} />
                <div>
                  <h3 className="text-2xl font-bold mb-2 text-white">Hours</h3>
                  <p className="text-[#A3A3A3]">
                    Monday - Sunday<br />
                    10:30 AM - 10:00 PM
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-neutral-900 border border-neutral-800 p-8 hover:border-[#D4AF37]/50 transition-colors duration-300">
              <div className="flex items-start space-x-4">
                <Instagram className="text-[#D4AF37] flex-shrink-0 mt-1" size={32} />
                <div>
                  <h3 className="text-2xl font-bold mb-2 text-white">Follow Us</h3>
                  <a
                    href="https://www.instagram.com/magictouchhairstudio/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-lg"
                    data-testid="instagram-link"
                  >
                    @magictouchhairstudio
                  </a>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <button
                data-testid="contact-whatsapp-btn"
                onClick={handleWhatsApp}
                className="w-full bg-[#D4AF37] text-black font-semibold px-8 py-4 uppercase tracking-widest text-sm hover:bg-[#E5C15D] transition-all duration-300 flex items-center justify-center space-x-3"
              >
                <Send size={20} />
                <span>Book via WhatsApp</span>
              </button>
              <button
                data-testid="contact-call-btn"
                onClick={handleCall}
                className="w-full border border-[#D4AF37] text-[#D4AF37] px-8 py-4 uppercase tracking-widest text-sm hover:bg-[#D4AF37] hover:text-black transition-all duration-300 flex items-center justify-center space-x-3"
              >
                <Phone size={20} />
                <span>Call Now</span>
              </button>
            </div>
          </div>

          {/* Map */}
          <div className="h-[600px] bg-neutral-900 border border-neutral-800 overflow-hidden">
            <iframe
              data-testid="google-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.4928431546996!2d72.86782607516891!3d19.20426048202383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b73b6b3b3b3b%3A0x3b3b3b3b3b3b3b3b!2sThakur%20Complex%2C%20Kandivali%20East%2C%20Mumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1234567890123"
              width="100%"
              height="100%"
              style={{ 
                border: 0,
                filter: 'invert(90%) hue-rotate(180deg)'
              }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Salon Location"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}
